import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { SessionProvider, useSession } from "./auth/SessionContext";
import { AppShell } from "./components/AppShell";
import { EmptyState } from "./components/ui";
import { BuildingDetailPage } from "./pages/BuildingDetailPage";
import { BuildingsPage } from "./pages/BuildingsPage";
import { ConnectorAdminPage } from "./pages/ConnectorAdminPage";
import { LoginPage } from "./pages/LoginPage";
import { NotificationAdminPage } from "./pages/NotificationAdminPage";
import { OverviewPage } from "./pages/OverviewPage";
import { ProblemDetailPage } from "./pages/ProblemDetailPage";
import { ProblemsPage } from "./pages/ProblemsPage";
import { WallboardPage } from "./pages/WallboardPage";
import { SearchX, ShieldCheck } from "lucide-react";
import { useDocumentTitle } from "./hooks/useDocumentTitle";
import { ThemeProvider } from "./theme/ThemeContext";

export function App() {
  return <ThemeProvider><SessionProvider><AppRoutes /></SessionProvider></ThemeProvider>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/ingresar" element={<LoginPage />} />
      <Route path="/mural" element={<ProtectedRoute><WallboardPage /></ProtectedRoute>} />
      <Route path="/*" element={<ProtectedRoute><AppShell><Routes>
        <Route path="/" element={<OverviewPage />} />
        <Route path="/problemas" element={<ProblemsPage />} />
        <Route path="/problemas/:id" element={<ProblemDetailPage />} />
        <Route path="/edificios" element={<BuildingsPage />} />
        <Route path="/edificios/:id" element={<BuildingDetailPage />} />
        <Route path="/administracion/conectores" element={<AdminRoute><ConnectorAdminPage /></AdminRoute>} />
        <Route path="/administracion/notificaciones" element={<AdminRoute><NotificationAdminPage /></AdminRoute>} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes></AppShell></ProtectedRoute>} />
    </Routes>
  );
}

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { authenticated, checking } = useSession();
  const location = useLocation();
  if (checking) return <div className="boot-screen"><span className="brand__mark"><ShieldCheck size={25} /></span><span>Preparando el monitoreo…</span></div>;
  if (!authenticated) return <Navigate to="/ingresar" replace state={{ from: location.pathname + location.search }} />;
  return children;
}

function AdminRoute({ children }: { children: React.ReactNode }) {
  const { role } = useSession();
  if (role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function NotFoundPage() {
  useDocumentTitle("Página no encontrada");
  return <div className="page page--center"><EmptyState icon={SearchX} title="Página no encontrada" description="La dirección no corresponde a una pantalla de Centro Monitoreo Hikdos." /></div>;
}
